<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div>
        <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :content_align_x="'hh'" />
    </div>
    <div class="tab-content mt-5" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>
    
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import FormDynamic from '@/components/FormDynamic.vue';
import moment from 'moment';
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "AssignmentTimeSquareFootage",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            rest_api: `search_standard_reports`,
            title_page: 'Daily Assignment Time and Square Footage Report',
            current_url: `/reports`,
            breadcrumb: Resources.breadcrumb,
            form_format: FormResources.form_format_assignment_time_square_footage,
            form_data: FormResources.form_data_assignment_time_square_footage,
            assignment_time_square_footage_table_headers: Resources.assignment_time_square_footage_table,
            search: '',
            first_request: true,
            pdfSource: '',
            standard_report_id: 23,
            array_options: {
                day_id: [],
                shift_id: []
            }
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async getInitialData() {
            const form_data = {
                module_id: this.standard_report_id,
                first_request: true,
            }

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) 
            {
                this.fill_data(response.data)

            } 
            else 
            {
                this.error_handling(response)
            }

            return response.data
        },

        async fill_data(data) {
            this.array_options = data
        },

        async getReport() 
        {
            const form_data = {
                standard_report_id: this.standard_report_id,
                headers: this.assignment_time_square_footage_table_headers,
                params: this.form_data
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) {
                const base64Data = await this.downloadFile(response, true)
                var blobUrl = URL.createObjectURL(base64Data);
                this.pdfSource = blobUrl
            } else {
                this.error_handling(response)
            }

            this.loader()
        },

    },

    async mounted() {
        if (this.hasPermissions(['Report Read', 'Report Write'])) 
        {
            this.getInitialData()
            this.form_data.day_id = moment().day()
        }
    },

    watch: {
        form_data: {
            handler() {
                this.getReport()
            },
            deep: true
        },
    }

}
</script>
